





































import { Vue, Component } from "vue-property-decorator";
import { Getter } from "vuex-class";
import getUrlParam from "@/common/utils/getUrlParam";

@Component
export default class ActivityMainImageIndex extends Vue {
  @Getter("groupSliderList") groupImageList!: Array<string>;
  @Getter('detailLoaded') detailLoaded!: boolean;
  type: string = getUrlParam("type") as string;
  currentIndex: number = 0;

  get notEmptyList(): Array<string> {
    return this.groupImageList.filter((value, index) => {
      return value || index === 0;
    });
  }

  get trueEmptyList(): Array<string> {
    return this.notEmptyList.filter(value => {
      return value;
    });
  }

  get scrollImageList(): Array<string> {
    if (this.trueEmptyList.length === 1) {
      return [];
    } else if (
      this.trueEmptyList.length === 2 ||
      this.trueEmptyList.length === 3
    ) {
      return this.trueEmptyList.concat(this.trueEmptyList);
    }
    return this.trueEmptyList;
  }

  mounted() {
    let timer: number;
    const sliderDom = document.querySelector(
      ".activity-slider-content"
    ) as HTMLElement;
    let startPos = 0;
    sliderDom.addEventListener("touchstart", (e: TouchEvent) => {
      // e.preventDefault();
      if (this.scrollImageList.length > 1) {
        startPos = e.touches[0].clientX;
      }
    });

    sliderDom.addEventListener("touchend", (e: TouchEvent) => {
      // e.preventDefault();
      if (this.scrollImageList.length > 1) {
        const endPos = e.changedTouches[0].clientX;
        if (endPos - startPos > 10) {
          window.clearInterval(timer);
          this.currentIndex =
            (this.currentIndex - 1 + this.scrollImageList.length) %
            this.scrollImageList.length;
          timer = window.setInterval(this.autoRoll, 3500);
        }
        if (endPos - startPos < -10) {
          window.clearInterval(timer);
          this.currentIndex =
            (this.currentIndex + 1) % this.scrollImageList.length;
          timer = window.setInterval(this.autoRoll, 3500);
        }
      }
    });
    timer = window.setInterval(this.autoRoll, 3500);
  }

  autoRoll() {
    if (this.scrollImageList.length > 1) {
      this.currentIndex = (this.currentIndex + 1) % this.scrollImageList.length;
    }
  }
}
